// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@guestsupply/App/Store/Reducers";
import { getDataLayer } from "@guestsupply/App/Utilities/DataLayer";
import { GOOGLE_EVENTS } from "@guestsupply/XDL/constants";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

type HandlerType = ApiHandler<{
    includePLPEvent: boolean | undefined;
    plpEventType: string;
    attribute?: string;
    clickText?: string;
    searchQuery?: string;
}>;

const XngGaPLPEvent: HandlerType = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    const currentPage = getCurrentPage(state).type;
    const currentBillTo = getCurrentBillToState(state).value;

    const { includePLPEvent, plpEventType, attribute, clickText, searchQuery } = props.parameter;

    if (includePLPEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        let googleAnalyticsData = {
            event: plpEventType,
            page_path: currentPage,
            brand_code: currentBillTo?.properties?.brand,
            exclusive: currentBillTo?.properties?.exclusive,
            group_descr: currentBillTo?.properties?.groupDescription,
        };

        if (plpEventType === GOOGLE_EVENTS.PLP_FILTER) {
            googleAnalyticsData = {
                ...googleAnalyticsData,
                click_text: clickText,
                attribute,
            } as any;
        } else if (plpEventType === GOOGLE_EVENTS.PLP_SEARCH) {
            googleAnalyticsData = {
                ...googleAnalyticsData,
                affiliation: currentBillTo?.companyName,
                search_term: searchQuery,
            } as any;
        }

        dataLayer.push(googleAnalyticsData);
    }
};

export const chain = [XngGaPLPEvent];

const xngGaPLPEvent = createHandlerChainRunner(chain, "XngGaPLPEvent");
export default xngGaPLPEvent;
